import { takeLatest, put, select } from 'redux-saga/effects';

import * as types from './types';
import selector from './selectors';
import { SIZE_CAP } from './reducer';
import { fetchTimelineData } from '../data/actions';

function* changeTimelineSizeCap(action) {
  const { increase } = action;
  const { timelineSizeCap } = yield select(selector);
  let newSizeCap = timelineSizeCap;
  if (increase) {
    newSizeCap += SIZE_CAP;
  } else {
    newSizeCap -= SIZE_CAP;
  }

  try {
    yield put({
      type: types.CHANGE_SIZE_CAP,
      newSizeCap,
    });
    yield put(fetchTimelineData());
  } catch (err) {
    console.error(err);
    throw err;
  }
}

function* watchChangeTimelineSizeCap() {
  yield takeLatest([types.CHANGE_SIZE_CAP_ACTION], changeTimelineSizeCap);
}

export default [watchChangeTimelineSizeCap];
